<template>
    <div class="form-group cps-multi-treeselect" v-if="IsShow">
        <h5 v-if="labelText && temp_value.length > 0" class="CPSForm-label" 
            :class="{ 'floatedLabel': (floatedLabel || $attrs['placeholder'] || temp_value) }">{{ $t(labelText) }}<span
                class="text-danger" v-if="validationRules"> *</span></h5>
        <ValidationProvider v-slot="{ errors }" :rules="validationRules" :vid="ControlId ? ControlId : ''">
            <treeselect ref="tree" v-model="temp_value" @input="updateValue" :disableBranchNodes="!IsHidenParentCheckbox" v-bind="$attrs"
                :placeholder="placeholder ? placeholder : labelText" :noResultsText="$t('lbl_EMPBE_NoResultFound')"
                :options="temp_options" searchPromptText="search" :multiple="true" @open="focusInput" @close="checkValue"  :options-top-level="true"
                @blur="checkValue" @select="selectNode" @deselect="delselect" :noOptionsText="$t('lbl_EMPBE_NoOptionsAvailable')"  :close-on-select="closeonselectValue"
                :appendToBody="appendToBodyEnabled" :zIndex="menuZIndex">

                <!-- 自定义复选框插槽 -->
                <template #checkbox-icon="{ node }">
                <div class="custom-checkbox" >
                    <span v-if="node.isSelected" class="check-icon">✓</span>
                    <span v-else-if="node.isIndeterminate" class="indeterminate-icon">–</span>
                </div>
                </template>
                <!-- 自定义label显示 -->
                <template #option-label="{ node, labelClassName }">

                    <div class="list-item">  
                        <span  class="item-text" style="margin-bottom: 0px;">
                            {{ node.raw.label }}
                        </span>
                         <span class="option-description" v-if="node.raw.description">{{ node.raw.description }}</span>
                    </div>
                </template>
                
                <!-- 自定义value显示 -->
                <template #value-label="{ node }">
                <span>{{ node.raw.label }}</span>
                </template>

            </treeselect>
            <b-form-invalid-feedback :state="false" v-if="(errors.length)">
                {{ $t(mandatoryText) }}
            </b-form-invalid-feedback>
        </ValidationProvider>
    </div>
</template>
<script>
// https://www.vue-treeselect.cn/
import Treeselect from '@riophae/vue-treeselect'

import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import Multiselect from 'vue-multiselect';
import { mapGetters } from 'vuex'
export default {
    props: {
        value: null,
        ControlId: null,
        isshow: null,
        mandatory: null,
        title: null,
        options: null,
        MaxLength: null,
        placeholder: null,
        IsHidenParentCheckbox: null,
        closeonselect: null,
        /** 下拉挂到 body，避免被下方卡片 / overflow 遮挡（公司信息应用行业等） */
        appendToBody: {
            type: Boolean,
            default: true,
        },
        zIndex: {
            type: [Number, String],
            default: 3000,
        },
    },
    data() {
        return {
            temp_value: this.value ? this.value : null,
            IsShow: true,
            labelText: this.title,
            mandatoryText: this.mandatory,
            validationRules: this.rules == null ? (this.mandatory == null ? null : { required: true }) : this.rules,
            floatedLabel: this.checkValue(),
            maxlength: this.MaxLength,
            temp_options: this.options,
            closeonselectValue:this.closeonselect?false:true
        }
    },
    components: {
        Multiselect, Treeselect
    },
    computed: {
        ...mapGetters({
            GetPermissionJsonById: 'responsePermission/getPermissionJsonById',
        }),
        record() {
            return this.GetPermissionJsonById({ ControlId: this.ControlId })
        },
        appendToBodyEnabled() {
            return this.appendToBody !== false;
        },
        menuZIndex() {
            const z = Number(this.zIndex);
            return Number.isFinite(z) && z > 0 ? z : 3000;
        },
    },
    watch: {
        value() {
            this.temp_value = this.value;
        },
        options() {
            this.temp_options = this.options
        }
    },
    mounted() {
        //read from json
        if (this.record != null) {
            if (this.record.IsShow != null) this.IsShow = this.record.IsShow;
            if (this.record.IsMandatory) this.validationRules = { required: true };
            if (this.record.IsDisable != null) this.$attrs["disabled"] = this.record.IsDisable;
            if (this.record.Label != null) this.labelText = this.$t(this.record.Label);
            if (this.record.PlaceholderLabel != null) this.$attrs["placeholder"] = this.$t(this.record.PlaceholderLabel);
            if (this.record.MandatoryLabel != null) this.mandatoryText = this.$t(this.record.MandatoryLabel);
            if (this.record.MaxLength != null) {
                this.$attrs["maxlength"] = this.record.MaxLength;
                this.maxlength = this.record.MaxLength;
            }
            if (this.record.MinLength != null) this.$attrs["minlength"] = this.record.MinLength;
        }
        if (this.temp_value) {
            this.updateValue()
        }
    },
    methods: {
        getValidationState({ dirty, validated, valid = null }) {
            return dirty || validated ? valid : null;
        },
        updateValue(e) {
            if (this.maxlength > 0 && this.temp_value.length >= this.maxlength) {
                this.disableAllOptions()
            } else {
                this.ableAllOptions();
            }
            this.$emit("input", this.temp_value);
        },
        disableAllOptions() {
            var that = this;
            this.temp_options = that.temp_options.map((data) => {
                if (data.children != undefined) {
                    return { ...data, children: that.disableChildOption(data.children) }
                } else {
                    var result = that.temp_value.filter((item) => item == data.id);
                    if (result.length > 0) {
                        return { ...data, isDisabled: false }
                    }
                    return { ...data, isDisabled: true }
                }
            })
        },
        disableChildOption(ParentData) {
            var that = this;
            return ParentData.map((data) => {
                if (data.children != undefined) {
                    return { ...data, children: that.disableChildOption(data.children) }
                } else {
                    var result = that.temp_value.filter((item) => item == data.id);
                    if (result.length > 0) {
                        return { ...data, isDisabled: false }
                    }
                    return { ...data, isDisabled: true }
                }
            })
        },
        ableAllOptions() {
            var that = this;
            this.temp_options = this.temp_options.map((data) => {
                if (data.children != undefined) {
                    return { ...data, children: that.ableChildOption(data.children) }
                } else {
                    return { ...data, isDisabled: false }
                }
            })
        },
        ableChildOption(ParentData) {
            var that = this;
            return ParentData.map((data) => {
                if (data.children != undefined) {
                    return { ...data, children: that.ableChildOption(data.children) }
                } else {
                    return { ...data, isDisabled: false }
                }
            })
        },


        getValidationStateClass(errors) {
            if (errors.length <= 0) {
                return "is-valid";
            }
            else {
                return "";
            }
        },
        addTag(newTag) {
            const tag = {
                name: newTag,
                code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
            };
            this.options.push(tag);
            this.temp_value.push(tag);
        },
        focusInput() {
            this.floatedLabel = true;
        },
        checkValue() {
            if (this.temp_value != undefined && this.temp_value.length > 0) {
                this.floatedLabel = true;
            } else {
                this.floatedLabel = false;
            }
        },
        selectNode(node, instance) {
            console.log('selected node', node);
            this.$emit("select", node);
        },
        delselect(node) {
            console.log('delselected node', node);
            this.$emit("delselect", node);
        },
    }
}
</script>
<style scoped> 
:deep(.vue-treeselect__checkbox) {
  width: 15px !important;
  height: 15px !important; 
   font-size: 14px!important; 
  border-color: rgba(0, 0, 0, 0.40)!important
}

:deep(.vue-treeselect__checkbox--checked) {
  background-color: #E8340C !important;
  border-color: #E8340C !important;
}

:deep(.vue-treeselect__checkbox--indeterminate) {
  background-color: #e6a23c !important;
  border-color: #e6a23c !important;
}

:deep(.vue-treeselect__check-mark) {
  stroke: white !important;  
stroke-width:  15px !important; 
transform: translate(20%, 10%); 
}
 
 
</style>
<style >
  
   .list-item{
    padding: 8px 16px;
    padding-left: 4px;
    min-height: 36px;
    max-height: 52px; 
    /* display: flex;  */
    text-align: left;
    gap: 4px;
   } 
   .item-text{
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    color: rgba(0, 0, 0, 0.8);
    font-size: 14px;
    /* font-family: Inter; */
    font-weight: 400;
    line-height: 18.2px;
    cursor: pointer;
   } 
 .option-description {
color: rgba(0, 0, 0, 0.40);
font-size: 12px;
/* font-family: Inter; */
font-style: italic;
font-weight: 400;
line-height: 15.60px;
}

:deep(.vue-treeselect__menu) {
  max-height: 400px; /* 调整最大高度 */ 
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15); /* 阴影 */
  gap: 4px;
}
.cps-multi-treeselect .vue-treeselect__placeholder {
    color: grey;
    font-size: 14px;
    /* font-family: "Microsoft Yahei", Arial, Helvetica, Arial, sans-serif !important; */
    /* font-family: Roboto; 移到vue-treeselect__multi-value*/
    font-weight: normal;
    margin-left: 20px;
    left: -14px !important;
}
.cps-multi-treeselect .vue-treeselect__control{
  padding: 0px;
} 
.cps-multi-treeselect .vue-treeselect__multi-value{
    margin:5px 10px !important;
    /* font-family: Roboto; */
}
.cps-multi-treeselect .vue-treeselect__multi-value-item{
    background: #F1F0FF;
    color: rgba(0, 0, 0, 0.80);
    border-radius: 999px;
        padding: 8px 8px 8px 12px;
    font-size: 14px;
/* font-family: Inter; */
font-weight: 500;
line-height: 14px;
}
.cps-multi-treeselect .vue-treeselect--has-value .vue-treeselect__multi-value{
    padding-bottom: 0px;
   margin-bottom: 0px;
}
.cps-multi-treeselect .vue-treeselect__multi-value-item-container{
    padding:2px;
}
.cps-multi-treeselect .vue-treeselect__multi-value-label{
        padding: 0 4px 0 0;
}
.cps-multi-treeselect .vue-treeselect__value-remove{
color: rgba(0, 0, 0, 0.40);
    padding-left: 4px;
   border: 0;
}
.cps-multi-treeselect .vue-treeselect__value-remove > svg{
    width: 9.3px;
    height: 9.3px;
}
</style>